import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`中國信託商業銀行創立於 1966 年，數十年來伴隨臺灣經濟成長，發展成具備完善金融服務的區域型銀行。在「正派經營」、「親切服務」的經營理念下，中國信託銀行締造許多令人驕傲的創新服務，從發行臺灣第一張信用卡、成立第一家銀行客服中心，到推動流程數位化，引領臺灣金融業數位轉型。截至 2019 年底，合併資產規模達新臺幣 4.23 兆元，不僅為臺灣最大民營銀行，且獲利、第一類資本規模、客戶數等指標，皆高居全臺灣所有銀行之冠。`}</p>
    <p>{`中國信託銀行服務據點遍及全球，在臺灣共有 152 家分行，並於 14 個國家及地區設有 116 處海外分支機構，為臺灣最國際化的銀行。海外布局以大中華、日本、北美及東南亞為重心，設有東京之星子行、美國子行、加拿大子行、菲律賓子行及印尼子行，深耕在地客戶，並提供國際企業完善之跨境金融服務。呼應政府新南向政策，近年透過越南、印度及新加坡分行積極拓展東南亞業務，更為第一家參股泰國當地金控 LH Financial Group Public Company Limited 之臺灣銀行；在大中華區以上海為中心，深耕長三角經濟圈及粵港澳大灣區，提供客戶便捷完整的服務網絡。`}</p>
    <p>{`展望未來，中國信託銀行將秉持 We are family 的品牌精神，在營運績效、公司治理、企業社會責任、環境永續等面向持續努力，為客戶、員工、股東與社會創造共同利益，打造「臺灣第一、亞洲領先」的領導品牌，期許成為治理最佳、客戶及股東心目中最值得信賴的金融服務機構。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      